<div style="position: relative;width:100%;height: 100%;">
    <canvas #chartCanvas  ></canvas>
</div>